import posthog from "posthog-js";

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY || "phc_rM4URJ83cw7nXH8YTVfDGmyM3rffQPPwvaocC5JUCvLB";
const POSTHOG_HOST = import.meta.env.VITE_POSTHOG_HOST || "https://analytics.rrc.tenants.nebulabet.io";

export const initAnalytics = () => {
  posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: "identified_only",
    autocapture: true,
    capture_pageview: true,
    capture_pageleave: true,
  });
};

export const identifyUser = user => {
  if (!user?.sub) return;
  posthog.identify(user.sub, {
    email: user.email,
    username: user.preferred_username || user.email,
  });
};

export const resetAnalytics = () => {
  posthog.reset();
};

export const captureEvent = (event, properties = {}) => {
  posthog.capture(event, properties);
};

// Specific events
export const captureDepositInitiated = ({method, amount} = {}) => {
  posthog.capture("deposit_initiated", {
    method: method || "unknown",
    ...(amount !== undefined && {amount}),
  });
};

export const captureGameLaunched = ({gameId, gameName, provider, category} = {}) => {
  posthog.capture("game_launched", {
    game_id: gameId,
    game_name: gameName,
    provider,
    category,
  });
};

export default posthog;
